import axios from "../../interceptors/axiosInterceptor";
import { getAuthOptions } from "../../config/Headers";
import { ICreateNewsfeedPayload, IGetQueryParams } from "interfaces/Index";
import {
  CREATE_NEWSFEED_URL,
  GET_NEWSFEED_LIST_URL,
  UPDATE_NEWSFEED_URL,
} from "config/Url";
import { normalizeFetchNewsfeedListResponse } from "normalizer/NewsfeedNormalizer";
import { normalizeCatchErrors } from "utils/errorUtils";
import { SOMETHING_WENT_WRONG } from "config/constants";

export const fetchNewsfeedListApiCall = (queryParam: IGetQueryParams = {}) =>
  new Promise((resolve, reject) => {
    let requestConfig: any = getAuthOptions();
    requestConfig.params = queryParam;
    axios
      .get(GET_NEWSFEED_LIST_URL, requestConfig)
      .then((response) => {
        if (response) {
          const data = response && response.data;
          const pageNumber: number = queryParam.page
            ? Number(queryParam.page) + 1
            : 1;
          const isPaginatedRes =
            queryParam.page && (queryParam.page as any) > 0 && data.length >= 25
              ? true
              : false;
          resolve(
            normalizeFetchNewsfeedListResponse(data, pageNumber, isPaginatedRes)
          );
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const createNewsfeedApiCall = (payload: ICreateNewsfeedPayload) =>
  new Promise<void>((resolve, reject) => {
    axios
      .post(CREATE_NEWSFEED_URL, payload, getAuthOptions())
      .then((response) => {
        if (response) {
          resolve();
        } else {
          reject({ errors: SOMETHING_WENT_WRONG });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const updateNewsfeedApiCall = (
  id: string,
  payload: ICreateNewsfeedPayload
) =>
  new Promise<void>((resolve, reject) => {
    let url = UPDATE_NEWSFEED_URL.replace("{postId}", id);
    axios
      .put(url, payload, getAuthOptions())
      .then((response) => {
        if (response) {
          resolve();
        } else {
          reject({ errors: SOMETHING_WENT_WRONG });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });
